<template>
<svg xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 70.402 70.402">
  <g id="Group_73" data-name="Group 73" transform="translate(-315.73 -280.287)">
    <circle id="Ellipse_26" data-name="Ellipse 26" cx="35.201" cy="35.201" r="35.201" transform="translate(315.73 280.287)" fill="#fff"/>
    <g id="Group_35" data-name="Group 35">
      <g id="Group_33" data-name="Group 33">
        <path id="Path_115" data-name="Path 115" d="M366.868,303.7h0s-4.082,2.95-5.054,3.57c-2.4,1.527-7.861,1.973-10.234,2.131a1.58,1.58,0,0,0-1.354,1.557v.077a1.581,1.581,0,0,0,1.354,1.558c.708.047,1.669.126,2.761.25,0,.715-.18,5.5-.18,5.5-.424-.165-1.823-.708-2.252-.87-.787-.3-6.243-2.09-8.967-2.756a7.092,7.092,0,0,0,.771-.454c.1-.065.192-.139.289-.209.164-.123.32-.253.471-.389a7.4,7.4,0,1,0-10.513-.963c.076.1.154.193.235.286.155.172.31.339.48.5a7.169,7.169,0,0,0,.685.565c.1.071.189.145.289.211a7.25,7.25,0,0,0,.781.458c-5.148,2.99-4.779,6.5-4.779,16.784h20.611a27.3,27.3,0,0,0-1.169-8.42c1.546.489,3.111,1.009,4.649,1.533l.167.057a2.526,2.526,0,0,0,.9.132,2.568,2.568,0,0,0,2.485-2.65l-.275-8.5a8.806,8.806,0,0,1,2.793,1.069c.606.434,5.054,3.545,5.054,3.545Z" fill="#1a1818"/>
      </g>
      <g id="Group_34" data-name="Group 34">
        <path id="Path_116" data-name="Path 116" d="M373.544,318.052l-.7-.485a11.366,11.366,0,0,0-.183-13.208l.687-.5a12.137,12.137,0,0,1,1.843,10.79A12.333,12.333,0,0,1,373.544,318.052Z" fill="#1a1818"/>
        <path id="Path_117" data-name="Path 117" d="M371.624,316.674l-.7-.482a9.026,9.026,0,0,0-.178-10.449l.687-.5a9.866,9.866,0,0,1,.191,11.435Z" fill="#1a1818"/>
        <path id="Path_118" data-name="Path 118" d="M369.706,315.294l-.706-.477a6.656,6.656,0,0,0-.167-7.694l.684-.5a7.45,7.45,0,0,1,1.152,6.654A7.57,7.57,0,0,1,369.706,315.294Z" fill="#1a1818"/>
      </g>
    </g>
  </g>
</svg>
</template>

<script>
export default {
  'name': 'SA_02_02_a',
  'props': {
    'size': {
      type: Number,
      default: 40
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/icons/attributes/SC_02_02_a.vue